<script setup lang="ts">
import type { DropdownMenuItem } from "@nuxt/ui"

import { useLangsStore } from "../../stores/langs"
import { useUserStore } from "../../stores/user"
const LangsStore = useLangsStore()

const UserStore = useUserStore()
defineProps<{
	collapsed?: boolean
}>()
const open = defineModel() as unknown

// const user = ref({
// 	name: 'Dexterial',
// 	avatar: {
// 		src: 'https://github.com/dexterial.png',
// 		alt: 'Dexterial',
// 	},
// })

// const users = await getCurrentUser()

const login_items = computed<DropdownMenuItem[][]>(() => [
	[
		{
			type: "label",
			label: UserStore.user_full?.auth?.email
				? UserStore.user_full?.auth?.email
				: LangsStore.getLangEntry("base_langs", "global-annonym"),
			icon: UserStore.user_full?.auth?.email ? "" : "i-lucide-annoyed",
			avatar: {
				src: UserStore.user_full?.auth?.photoURL ? UserStore.user_full?.auth?.photoURL : "",
			},
		},

		{
			label: LangsStore.getLangEntry("base_langs", "global-logout"),
			icon: "i-lucide-log-out",
			color: "error",
			onSelect: () => {
				UserStore.signOutUser()
			},

			class: UserStore.user_full?.auth ? "" : "hidden",
		},
		{
			label: LangsStore.getLangEntry("base_langs", "global-login"),
			icon: "i-lucide-log-in",
			color: "primary",
			onSelect: () => {
				UserStore.signinPopup()
			},
			class: UserStore.user_full?.auth ? "hidden" : "",
			// class: 'hidden',
		},
	],
])
</script>

<template>
	<!-- {{ UserStore.user_full.auth }} -->
	<!-- {{ UserStore.user_full?.auth?.photoURL }} -->
	<!-- UserStore.user_full?.auth.id -->
	<!-- {{ UserStore.user_full?.auth?.uid }} -->
	<UDropdownMenu
		:items="login_items"
		class=""
		:content="{ align: 'center', collisionPadding: 12, side: 'top', sideOffset: 8 }"
		:ui="{ content: collapsed ? 'w-48' : 'w-(--reka-dropdown-menu-trigger-width)' }"
	>
		<UButton
			v-bind="{
				label: collapsed
					? undefined
					: UserStore.user_full?.auth?.displayName
						? UserStore.user_full?.auth?.displayName
						: LangsStore.getLangEntry('base_langs', 'global-annonym'),
				// trailingIcon: 'i-lucide-chevrons-down',
			}"
			:avatar="{
				src: UserStore.user_full?.auth?.photoURL ? UserStore.user_full?.auth?.photoURL : '',
			}"
			:icon="UserStore.user_full?.auth?.email ? '' : 'i-lucide-annoyed'"
			color="neutral"
			variant="ghost"
			block
			:square="collapsed"
			class="data-[state=open]:bg-(--ui-bg-elevated)"
			:ui="{
				trailingIcon: 'text-(--ui-text-dimmed)',
			}"
		/>

		<template #chip-leading="{ item }">
			<span
				:style="{ '--chip': `var(--color-${(item as any).chip}-400)` }"
				class="ms-0.5 size-2 rounded-full bg-(--chip)"
			/>
		</template>
	</UDropdownMenu>
	<!-- <UNavigationMenu
		:collapsed="collapsed"
		:items="items"
		orientation="vertical"
	/> -->

	<!-- <USelect
			v-model="LangsStore.context.lang_id"
			:items="LangsStore.langs_ids"
			class="mb-2 w-full"
			:leading-icon="'i-lucide-globe'"
			@change="setQPar(LangsStore.context, 'lang_id')"
		/> -->
</template>
